import _regeneratorRuntime from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { ref, computed } from "vue";
import { useRoute } from "vue-router/composables";
import { useStore } from "vue2-helpers/vuex";
import moment from "moment";
import { createData, deleteData } from "@/services/axios";
import LoadingMessage from "@/components/common/LoadingMessage.vue";
import ConfirmSlotModal from "@/components/common/ConfirmSlotModal.vue";
import UrlToLink from "@/components/common/UrlToLink.vue";
import { useMessageUrlValidator } from "@/composables/messageUrlValidator";
export default {
  __name: 'ForumDetailComment',
  props: {
    commentList: {
      /** @type {PropType<Object<string, any>[]>} */
      type: Array,
      required: true
    }
  },
  emits: ["setData"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    // @ts-check
    var route = useRoute();
    var store = useStore();
    var me = computed(function () {
      return store.state.me;
    });
    var isLoading = ref(false);
    var commentMessage = ref("");

    var _useMessageUrlValidat = useMessageUrlValidator(commentMessage),
        isUrlValidate = _useMessageUrlValidat.isUrlValidate;

    var isShowDeleteConfirmModal = ref(false);
    var deleteTargetId = ref(null);

    var handleCommentDeleteButton = function handleCommentDeleteButton(event) {
      isShowDeleteConfirmModal.value = true;
      deleteTargetId.value = event.target.value;
    };

    var hideConfirmModal = function hideConfirmModal() {
      isShowDeleteConfirmModal.value = false;
    };

    var createForumComment = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var payload;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                payload = {
                  school_forum_id: route.params.id,
                  message: commentMessage.value
                };
                _context.prev = 1;
                isLoading.value = true;
                _context.next = 5;
                return createData("school_forum_comments", payload);

              case 5:
                isLoading.value = false;
                emit("setData");
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                console.log(_context.t0);
                isLoading.value = false;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 9]]);
      }));

      return function createForumComment() {
        return _ref2.apply(this, arguments);
      };
    }();

    var deleteForumComment = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!deleteTargetId.value) {
                  _context2.next = 14;
                  break;
                }

                _context2.prev = 1;
                isLoading.value = true;
                _context2.next = 5;
                return deleteData("school_forum_comments/".concat(deleteTargetId.value));

              case 5:
                deleteTargetId.value = null;
                isLoading.value = false;
                emit("setData");
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](1);
                console.log(_context2.t0);
                isLoading.value = false;

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 10]]);
      }));

      return function deleteForumComment() {
        return _ref3.apply(this, arguments);
      };
    }();

    return {
      __sfc: true,
      route: route,
      store: store,
      emit: emit,
      me: me,
      isLoading: isLoading,
      commentMessage: commentMessage,
      isUrlValidate: isUrlValidate,
      isShowDeleteConfirmModal: isShowDeleteConfirmModal,
      deleteTargetId: deleteTargetId,
      handleCommentDeleteButton: handleCommentDeleteButton,
      hideConfirmModal: hideConfirmModal,
      createForumComment: createForumComment,
      deleteForumComment: deleteForumComment,
      moment: moment,
      LoadingMessage: LoadingMessage,
      ConfirmSlotModal: ConfirmSlotModal,
      UrlToLink: UrlToLink
    };
  }
};